import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import {
  ECommitteeEvaluationStatus,
  ICommitteeEvaluation,
  ICommitteeEvaluations,
} from 'types/committee-evaluation';
import { IPaginationQueryInfo } from 'types/pagination'

type ICMDPaginationQueryInfo = IPaginationQueryInfo & {
  status: ECommitteeEvaluationStatus
}

type CommitteeEvaluationAction = {
  tenderId: string
  decisionNote: string
  committeeEvaluationId?: string
}

export const committeeEvaluationApi = createApi({
  reducerPath: 'committeeEvaluation',
  baseQuery,
  tagTypes: ['CommitteeEvaluation'],
  endpoints: (builder) => ({
    committeeEvaluationOverview: builder.query<
      ICommitteeEvaluations,
      ICMDPaginationQueryInfo
    >({
      query: (params) => {
        return {
          url: '/committee-evaluation/overview',
          method: 'get',
          params,
        }
      },
      providesTags: ['CommitteeEvaluation'],
    }),
    acceptCommitteeEvaluation: builder.mutation<
      ICommitteeEvaluation,
      Partial<CommitteeEvaluationAction>
    >({
      query: (body) => ({
        url: `/committee-evaluation/accept`,
        body,
        method: 'post',
      }),
    }),
    rejectCommitteeEvaluation: builder.mutation<
      ICommitteeEvaluation,
      Partial<CommitteeEvaluationAction>
    >({
      query: (body) => ({
        url: `/committee-evaluation/reject`,
        body,
        method: 'post',
      }),
    }),
  }),
})

export const {
  useCommitteeEvaluationOverviewQuery,
  useAcceptCommitteeEvaluationMutation,
  useRejectCommitteeEvaluationMutation,
} = committeeEvaluationApi
